module.exports = __webpack_public_path__ + "img/Pdf.116a2dc5.jpg";